module.exports = __webpack_public_path__ + "img/SOKAL-SRS-121021-Eclipse-Modern.2d9564bc.jpeg";